module.exports = __webpack_public_path__ + "img/Electric.c04ebbb0.svg";